import _get from 'lodash/get';

enum HotelRoomMappingType {
    SINGLE = 'SINGLE',
    SLOT_SINGLE_STANDARD_1 = "SLOT_SINGLE_STANDARD_1",
    SLOT_SINGLE_STANDARD_2 = "SLOT_SINGLE_STANDARD_2",
    SLOT_SINGLE_STANDARD_3 = "SLOT_SINGLE_STANDARD_3",
    SLOT_SINGLE_STANDARD_4 = "SLOT_SINGLE_STANDARD_4",
    STANDARD = 'STANDARD',
    SLOT_STANDARD_PREMIUM_1 = "SLOT_STANDARD_PREMIUM_1",
    SLOT_STANDARD_PREMIUM_2 = "SLOT_STANDARD_PREMIUM_2",
    SLOT_STANDARD_PREMIUM_3 = "SLOT_STANDARD_PREMIUM_3",
    SLOT_STANDARD_PREMIUM_4 = "SLOT_STANDARD_PREMIUM_4",
    PREMIUM = 'PREMIUM',
    SLOT_PREMIUM_SUITE_1 = "SLOT_PREMIUM_SUITE_1",
    SLOT_PREMIUM_SUITE_2 = "SLOT_PREMIUM_SUITE_2",
    SLOT_PREMIUM_SUITE_3 = "SLOT_PREMIUM_SUITE_3",
    SLOT_PREMIUM_SUITE_4 = "SLOT_PREMIUM_SUITE_4",
    SUITE = 'SUITE',
    SLOT_SUITE_NONE_1 = "SLOT_SUITE_NONE_1",
    SLOT_SUITE_NONE_2 = "SLOT_SUITE_NONE_2",
    SLOT_SUITE_NONE_3 = "SLOT_SUITE_NONE_3",
    SLOT_SUITE_NONE_4 = "SLOT_SUITE_NONE_4",
    NONE = 'NONE'
}

export const ROOM_MAPPING_TYPE_ORDER = [
    HotelRoomMappingType.SINGLE,
    HotelRoomMappingType.SLOT_SINGLE_STANDARD_1,
    HotelRoomMappingType.SLOT_SINGLE_STANDARD_2,
    HotelRoomMappingType.SLOT_SINGLE_STANDARD_3,
    HotelRoomMappingType.SLOT_SINGLE_STANDARD_4,
    HotelRoomMappingType.STANDARD,
    HotelRoomMappingType.SLOT_STANDARD_PREMIUM_1,
    HotelRoomMappingType.SLOT_STANDARD_PREMIUM_2,
    HotelRoomMappingType.SLOT_STANDARD_PREMIUM_3,
    HotelRoomMappingType.SLOT_STANDARD_PREMIUM_4,
    HotelRoomMappingType.PREMIUM,
    HotelRoomMappingType.SLOT_PREMIUM_SUITE_1,
    HotelRoomMappingType.SLOT_PREMIUM_SUITE_2,
    HotelRoomMappingType.SLOT_PREMIUM_SUITE_3,
    HotelRoomMappingType.SLOT_PREMIUM_SUITE_4,
    HotelRoomMappingType.SUITE,
    HotelRoomMappingType.SLOT_SUITE_NONE_1,
    HotelRoomMappingType.SLOT_SUITE_NONE_2,
    HotelRoomMappingType.SLOT_SUITE_NONE_3,
    HotelRoomMappingType.SLOT_SUITE_NONE_4,
    HotelRoomMappingType.NONE
];

export const sortRoomMappingTypes = (types: HotelRoomMappingType[]): HotelRoomMappingType[] => {
    return types.sort((a, b) => ROOM_MAPPING_TYPE_ORDER.indexOf(a) - ROOM_MAPPING_TYPE_ORDER.indexOf(b));
};

export const sortByRoomMappingType = (list: any[], property: string) => {
    list.sort((a, b) => {
        const aProperty = _get(a, property) as HotelRoomMappingType;
        const bProperty = _get(b, property) as HotelRoomMappingType;
        const firstIndex = ROOM_MAPPING_TYPE_ORDER.indexOf(aProperty);
        const secondIndex = ROOM_MAPPING_TYPE_ORDER.indexOf(bProperty);

        if (firstIndex === -1 && secondIndex === -1) {
            return aProperty.localeCompare(bProperty);
        }

        if (firstIndex === -1) return 1;
        if (secondIndex === -1) return -1;

        return firstIndex - secondIndex;
    });
}

export default HotelRoomMappingType;